export default __webpack_public_path__ + "static/media/at-sign-2.4821602f.svg";